import React from 'react';
import PortraitScoreBar from '../oracle/PortraitScoreBar';
import { formatScore10, formatScanDate } from './format';

// YOUR ARCHIVE picker strip: horizontal scroll of real vault thumbnails.
// 92px thumbs on desktop, 78px on mobile. Selected entries get the gold
// border + glow and a BEFORE / AFTER bottom tag.
const ArchiveStrip = ({ entries, beforeId, afterId, onPick }) => (
  <div className="flex gap-2 lg:gap-3 mt-2.5 lg:mt-3.5 overflow-x-auto pb-1.5">
    {entries.map((entry) => {
      const tag =
        entry.scan_id === beforeId ? 'BEFORE' : entry.scan_id === afterId ? 'AFTER' : null;
      const score10 = formatScore10(entry.overall_score);
      const dateLabel = formatScanDate(entry);
      return (
        <button
          key={entry.scan_id}
          type="button"
          onClick={() => onPick(entry)}
          aria-label={`select scan ${dateLabel}, score ${score10}`}
          className={[
            'relative w-[78px] lg:w-[92px] shrink-0 cursor-pointer p-0 text-left',
            'rounded-[9px] lg:rounded-thumb overflow-hidden bg-[#121211] border',
            'transition-all duration-200 ease-mogged',
            tag
              ? 'border-aurum shadow-aurum-glow'
              : 'border-[rgba(255,255,255,0.10)] hover:border-[rgba(255,255,255,0.35)]',
          ].join(' ')}
        >
          <div className="relative h-24 lg:h-28">
            <img
              src={entry.thumbnail_url}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
            <PortraitScoreBar score={score10} size="xs" inset="6%" />
            {tag && (
              <div className="absolute left-0 right-0 bottom-0 bg-[rgba(201,164,92,0.92)] text-center font-display text-[8px] lg:text-[9px] tracking-[0.18em] text-[#1A1A1A] py-[2px] lg:py-[3px]">
                {tag}
              </div>
            )}
          </div>
          <div className="hidden lg:block px-1 py-[7px] text-center font-display text-[11.5px] text-[#B8B2A6]">
            {dateLabel}
          </div>
        </button>
      );
    })}
  </div>
);

export default ArchiveStrip;
